import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'lusha-ui-components-v2';

import './DescriptionInfo.scss';

const DescriptionInfo = ({ descriptionText }) => (
  <div className="error-description-container">
    <div className="description-info-text">
      <Text variant="smallR">{descriptionText}</Text>
    </div>
  </div>
);

export default DescriptionInfo;

DescriptionInfo.propTypes = {
  descriptionText: PropTypes.string,
};
